import React, { useEffect, useState } from 'react';
import { Button, Col, Divider, Form, Row, Space } from 'antd';
import { MyInput } from '../../../components';
import { useDispatch, useSelector } from 'react-redux';
import { actionsApi } from '../../../shared';
import { apiCalls } from '../../../shared/Apis';

const ContactDetails = () => {
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch()
    const { footerData } = useSelector(state => state.FooterdetailsApi)

    useEffect(()=>{
        dispatch(actionsApi?.getFooterdetailsapi())
    },[dispatch])

    useEffect(()=>{
        if(footerData){
            form.setFieldsValue({
                contactNumber: +footerData?.contactNumber,
                email: footerData?.email
            })
        }
    },[footerData,form])

    const FooterPost = async(FormData) => {
        setLoading(true);
        const result = await apiCalls?.FooterPostApi?.FooterPost({...FormData, id: footerData?.id})
        if(result){
            setLoading(false);
        }
    }

    const onFinish = async () => {
        try {
            const formData = await form.validateFields();
            FooterPost(formData);
        } catch (error) {
            console.error("Form validation error:", error);
        }
    };


    return (
        <Form
            form={form}
            layout="vertical"
            requiredMark={false}
            onFinish={onFinish}
        >
            <Row gutter={16}>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        type='number'
                        name='contactNumber'
                        label="Contact Number"
                        required
                        message='please enter contact number'
                        size='large'
                    />
                </Col>
                <Col lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                    <MyInput
                        type='email'
                        name='email'
                        label="Email"
                        required
                        message='please enter email'
                        size='large'
                    />
                </Col>
                <Col span={24}>
                    <Divider />
                </Col>
                <Col span={24}>
                    <Space className="w-100 right flex-reverse" wrap>
                        <Button 
                            className="btncancel"
                        >
                            Cancel
                        </Button>
                        <Button  
                            block
                            className='btnsave'
                            type="primary"
                            htmlType="submit"
                            loading={loading}
                        >
                            Save Changes
                        </Button>
                    </Space>
                </Col>
            </Row>
        </Form>
    );
};

export { ContactDetails };
